/**
 * @flow
 * @format
 */
const initialState = {};

const notificationReducer = function(state = initialState, action) {
  switch (action.type) {
    case 'SET_NOTI_COUNT': {
      return {count: action.count};
    }
    default: {
      return state;
    }
  }
};

export const setNotiCount = (count, dispatch) => {
  if(dispatch) {
    dispatch({type: 'SET_NOTI_COUNT', count});
  }
};

export default notificationReducer;
